import { ConditionGroup } from '../../../models/filter-group.model';

export interface ContractFlags {
  hq: boolean;
  ru: boolean;
  da: boolean;
}

export interface ContractUiFlags {
  contractDateEnabled: boolean;
  contractOptions: boolean;
  ruContractOptions: boolean;
  daContractOptions: boolean;
}

const CONTRACT_TYPE_FIELD = 'contract type';
const CONTRACT_DATE_FIELD = 'contract date';

export function detectContractTypes(groups: ConditionGroup[]): ContractFlags {
  const contractMap: Record<string, keyof ContractFlags> = {
    'hq contract': 'hq',
    'ru contract': 'ru',
    'd&a contract': 'da',
  };
  const flags: ContractFlags = { hq: false, ru: false, da: false };

  for (const group of groups) {
    for (const cond of group.conditions) {
      const normalizedField = cond.field?.trim().toLowerCase() || '';
      if (
        normalizedField !== CONTRACT_TYPE_FIELD ||
        !cond.value ||
        typeof cond.value !== 'string'
      ) {
        continue;
      }

      const key = cond.value.trim().toLowerCase();
      const mappedFlag = contractMap[key];
      if (mappedFlag) {
        flags[mappedFlag] = true;
      }
    }
  }

  return flags;
}

export function getContractUiFlags(flags: ContractFlags): ContractUiFlags {
  return {
    contractDateEnabled: !(flags.hq || flags.ru || flags.da),
    contractOptions: !flags.hq,
    ruContractOptions: !flags.ru,
    daContractOptions: !flags.da,
  };
}

export function isFieldDisabledByContractType(
  field: string,
  uiFlags: ContractUiFlags,
  hqFields: Set<string>,
  ruFields: Set<string>,
  daFields: Set<string>,
): boolean {
  const normalizedField = field?.trim().toLowerCase() || '';

  if (normalizedField === CONTRACT_DATE_FIELD) return uiFlags.contractDateEnabled;
  if (hqFields.has(normalizedField)) return uiFlags.contractOptions;
  if (ruFields.has(normalizedField)) return uiFlags.ruContractOptions;
  if (daFields.has(normalizedField)) return uiFlags.daContractOptions;

  return false;
}

export function clearDisabledContractFieldValues(
  groups: ConditionGroup[],
  isDisabled: (field: string) => boolean,
): void {
  for (const group of groups) {
    for (const cond of group.conditions) {
      const normalizedField = cond.field?.trim().toLowerCase() || '';
      if (
        !cond.field ||
        normalizedField === CONTRACT_TYPE_FIELD ||
        !isDisabled(cond.field)
      ) {
        continue;
      }

      cond.value = Array.isArray(cond.value) ? [] : '';
      cond.valueTo = '';
    }
  }
}
